'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

exports.email = email;
exports.phone = phone;
exports.internationalPhone = internationalPhone;
exports.required = required;
exports.minLength = minLength;
exports.maxLength = maxLength;
exports.integer = integer;
exports.match = match;
exports.createValidator = createValidator;
exports.wholeNumbersStartingWithOne = wholeNumbersStartingWithOne;
exports.validatePassword = validatePassword;
exports.validateInternationalZipCode = validateInternationalZipCode;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var join = function join(rules) {
    return function (value, data) {
        return rules.map(function (rule) {
            return rule(value, data);
        }).filter(function (error) {
            return !!error;
        })[0];
    };
};

function email(value) {
    var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(value);
}

function phone(value) {
    var phoneRegex = /(?:(?:(\s*\(?([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\)?\s*(?:[.-]\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})/;
    return phoneRegex.test(value);
}

function internationalPhone(value) {
    return value;
}

function required(value) {
    if (typeof value === 'number') return true;
    return !(0, _isEmpty2.default)(value);
}

function minLength(min) {
    return function (value) {
        if (!(0, _isEmpty2.default)(value) && value.length < min) {
            return 'Must be at least ' + min + ' characters';
        }
    };
}

function maxLength(value, max) {
    return !(0, _isEmpty2.default)(value) && value.length <= max;
}

function integer(value) {
    if (!(0, _isInteger2.default)(Number(value))) {
        return 'Must be an integer';
    }
    return !(0, _isInteger2.default)(Number(value));
}

function match(field) {
    return function (value, data) {
        if (data) {
            if (value !== data[field]) {
                return 'Do not match';
            }
        }
    };
}

function createValidator(rules) {
    return function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var errors = {};
        (0, _keys2.default)(rules).forEach(function (key) {
            var rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
            var error = rule(data[key], data);
            if (error) {
                errors[key] = error;
            }
        });
        return errors;
    };
}

function wholeNumbersStartingWithOne(value) {
    var regExp = /^[1-9][0-9]*$/;
    return regExp.test(value);
}

function validatePassword(value) {
    return required(value) && value.length >= 6;
}

function validateInternationalZipCode(zipCode) {
    var zipCodeValidationRegex = /^[a-zA-Z0-9-_]+$/;
    return zipCodeValidationRegex.test(zipCode);
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/validation.js
// module id = /wT0
// module chunks = 46